<template>
    <div class="CreateNewTicket">
        <div class="label-md-bold-black">Submit a ticket</div>
        <el-row :gutter="15" class="top-margin-15">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="form-group" :class="{'not-empty': email.length , 'form-group--error': $v.email.$error }">
                    <label class="input-label-bold-gray">Email address</label>&nbsp;<span class="required-field">*</span>
                    <input type="text" class="custom-input" placeholder="Email address" v-model="email" @input="setEmail($event.target.value)">
                </div>

                <div class="error" v-if="validate_email_id">
                    Enter valid email id
                </div>
                <div class="error" v-if="!$v.email.required">
                    Field is required
                </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="form-group" :class="{'not-empty': subject.length , 'form-group--error': $v.subject.$error }">
                    <label class="input-label-bold-gray">Subject</label>&nbsp;<span class="required-field">*</span>
                    <input type="text" class="custom-input" placeholder="Subject" v-model="subject">
                </div>

                <div class="error" v-if="!$v.subject.required">
                    Field is required
                </div>
            </el-col>
        </el-row>

        <el-row :gutter="15" class="top-margin-15">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="form-group" :class="{'not-empty': description.length , 'form-group--error': $v.description.$error }">
                    <label class="input-label-bold-gray">Description</label>&nbsp;<span class="required-field">*</span>
                    <textarea class="custom-input" style="resize: none; height: auto;" placeholder="Description" v-model="description" name="description" rows="2" cols="10"></textarea>
                </div>

                <div class="error" v-if="!$v.description.required">
                    Field is required
                </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <input type="file" style="display: none;" ref="supportFile" accept="image/png, image/jpeg" v-on:change="handleFileUpload()">
                <el-button class="top-margin-20" type="primary" plain size="small" icon="el-icon-plus" @click="$refs.supportFile.click()">Attach a file</el-button>

                <span class="label-xs-black left-margin-10" v-if="selected_file">{{ selected_file.name }}</span>
            </el-col>
        </el-row>

        <div class="text-right save-btn-section top-margin-20">
            <el-button type="primary custom-btn" @click="submitTicket()" :loading="ticket_submit_progress">Submit</el-button>
        </div>

        <el-dialog
            :visible.sync="openNotificationDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="true"
            :lock-scroll="true"
            class="ticket-raised-success-dialog"
            :before-close="closeTicketNotificationModal">
            <div class="flex-space-between flex-wrap">
                <div>
                    <div class="label-lg-black-bold">Your ticket has been created.</div>
                    <div class="label-xs-black top-margin-5">Thanks for reaching us.</div>
                    <div class="label-xs-black top-margin-5">Team will get back in 24 to 48 hrs.</div>
                </div>

                <div class="top-margin-10">
                    <el-button round class="btn1" size="mini" @click="openNotificationDialog = false; $router.push({path: '/dashboard'})">Go to Dashboard</el-button>


                    <!-- commit active state of support page in store to switch component -->
                    <el-button round class="btn2" size="mini" @click="openNotificationDialog = false; $store.commit('commitSupportPageActiveState', 'TRACK_TICKET')">Check Status</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { serverAddr, serverAddrToUploadMediaFiles, serverHostName } from "../networkConfig";
import { required, minValue, maxValue, email } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";

export default {
    name: 'CreateNewTicket',
    data() {
        return {
            email: '',
            subject: '',
            description: '',
            validate_email_id: false,
            selected_file: null,
            ticket_submit_progress: false,
            openNotificationDialog: false
        }
    },

    validations: {
        email: {
            required, email
        },
        subject: {
            required
        },
        description: {
            required
        }
    },

    methods: {
        setEmail(value){
            let regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(value.trim){
                // this.billing_name = value.trim();
                this.$v.email.$touch();
                if(this.email.match(regularExpression)) {
                    this.validate_email_id = false;
                } else if(this.email != "") {
                    this.validate_email_id = true;
                }
            }
        },

         handleFileUpload(){
            var temp_file = this.$refs.supportFile.files[0];
            if(temp_file){
                this.selected_file = temp_file;
            }
        },

        submitTicket(){
            this.$v.$touch();
            if (!this.$v.$invalid && !this.validate_email_id) {
                this.ticket_submit_progress = true;     //enabled loader

                let obj = {};
                obj.email = this.email;
                obj.subject = this.subject;
                obj.description = this.description;
                obj.status = "IN";
                obj.attachment = this.selected_file;

                let formData = new FormData();
                for(var key in obj){
                    formData.append(key, obj[key]);
                }

                serverAddrToUploadMediaFiles
                .post("/support/post_user_ticket/", formData)
                .then((response)=>{
                    if(response.data.status){
                        this.ticket_submit_progress = false;     //disabled loader

                        this.openNotificationDialog = true;      //displayed success dialog

                        this.selected_file = null;
                        this.email = '';
                        this.subject = '';
                        this.description = '';
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.ticket_submit_progress = false;     //disabled loader
                    this.openNotificationDialog = true;      //closed success dialog

                    new CripNotice({
                        title: "Oops! Something went wrong!",
                        description: "Please try again...",
                        type: "error",
                        duration: 3,
                    });
                });
            }
        },

        closeTicketNotificationModal(){
            this.openNotificationDialog = false;
        }
    },
}
</script>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.CreateNewTicket{
    .ticket-raised-success-dialog{
        .el-dialog{
            border-radius: 10px;
        }
        .el-dialog__body{
            padding: 20px 20px;
        }
        .btn1{
            background: $primary-theme-color;
            color: #fff;
            border-color: $primary-theme-color;
            font-size: 12px;
            height: 25px;
            line-height: 0.8;
            margin-bottom: 10px;
        }
        .btn2{
            background: #fff;
            color: $primary-theme-color;
            border-color: $primary-theme-color;
            font-size: 12px;
            height: 25px;
            line-height: 0.8;
            margin-bottom: 10px;
        }
    }

    @media screen and (max-width: 992px) {
        .ticket-raised-success-dialog{
            .el-dialog{
            width: 80%;
            }
        }
    }
}
</style>
